module.exports = __webpack_public_path__ + "static/media/gallaxy-background-contact.c0cd6c52.webp";